import React, { Component } from "react";

import Icon from "material-ui-next/Icon";

import { colors } from "assets";

export default class ImportStockCount extends Component {
  render() {
    const borderStyle = {
      cursor: "pointer",
      borderWidth: 2,
      borderColor: "#16303d",
      borderStyle: "dashed",
      borderRadius: 5,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      padding: "0px 12px",
      height: 200,
      opacity: 0.6
    };

    const textStyle = {
      fontWeight: 350,
      fontSize: 22
    };

    const iconStyle = {
      opacity: 1,
      fontSize: "56px",
      width: "50px",
      color: colors.primary.dark
    };

    const { downloadCsv } = this.props;

    return (
      <div style={{ ...borderStyle }} onTouchTap={downloadCsv}>
        <Icon style={{ ...iconStyle }}>file_download</Icon>
        <span style={{ ...textStyle }}>
          Clique para fazer download da planilha.
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/download-step/index.js